export default __webpack_public_path__ + "static/media/verify-email.571ee543829e010e275e4b76ba9507e5.svg";